import { useGroups } from '@entities/common/groups';
import type React from 'react';
import { useLayoutEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBackIosNew } from '@mui/icons-material';
import { /*Search,*/ useFilter } from '@features/common';
import { usePublicate } from '@features/events/event-editor/model';
// import { Search as SearchIcon } from '@shared/assets';
// import { useWindowWidth } from '@shared/hooks';
import type { Group } from '@shared/types/common';
import { Card, IconButton, ListBody, PageHead, PageTitle } from '@shared/ui';
import { Loader } from '@src/library/components/common';
import { useEvent } from '@src/library/hooks/events';
import * as st from './styles.module.scss';
import { CheckboxPublication } from './ui/checkbox';
import { AllToggle } from './ui/toggle-publication/ui';

export const PublicationPage: React.FC = () => {
  const { id } = useParams();
  const eventId = Number(id);
  const navigate = useNavigate();

  const { search, onSearch } = useFilter();

  const { event, status } = useEvent();
  const { publishAction, changeGroups } = usePublicate();

  const {
    groups,
    // groupTitles,
    selectedGroups,
    removeFromSelectedGroups,
    addSelectedToGroups,
    isSelectedAtAnyGroups,
    isSelectedGroupAll,
    groupAll,
    excludedGroups,
    prevSelectedGroups,
    setPrevSelectedGroups,
    initialGroupsForPublication,
  } = useGroups();

  const sortArraySpecialType: (Group | undefined)[] = groups
    .filter((group: Group) => {
      if (group.special_type !== null && group.special_type !== 'all') return group;
    })
    .sort((a: Group, b: Group) => {
      if (a.special_type === 'coaches') return 1;
      if (b.special_type === 'coaches') return 1;
      if (a!.name > b!.name) return 1;
      if (a!.name < b!.name) return -1;
      return 0;
    });

  const sortArrayNullType: (Group | undefined)[] = groups
    .filter((group: Group) => {
      if (group.special_type === null) return group;
    })
    .sort((a: Group, b: Group) => {
      if (a!.name > b!.name) return 1;
      if (a!.name < b!.name) return -1;
      return 0;
    });

  const sortGroups: (Group | undefined)[] = [...sortArraySpecialType, ...sortArrayNullType];

  const PublicationButtonClick = () => {
    setPrevSelectedGroups(selectedGroups);
    changeGroups(
      eventId,
      isSelectedGroupAll && groupAll ? [groupAll] : selectedGroups,
      excludedGroups
    );
  };

  // const windowWidth = useWindowWidth();

  const [isSearchMobile, setIsSearchMobile] = useState(false);

  const areArraysEqual = (groups1: Group[], groups2: Group[]): boolean => {
    if (groups1.length === groups2.length) {
      const arrIds1 = groups1.map((group1) => {
        if (group1.special_type !== 'all') return group1.id;
      });
      const arrIds2 = groups2.map((group2) => {
        if (group2.special_type !== 'all') return group2.id;
      });
      return arrIds1.every((arrId1) => arrIds2.includes(arrId1));
    }
    return false;
  };

  const getFullGroups = (groupsArr: Group[] | number[]): any[] => {
    if (Array.isArray(groupsArr) && groupsArr.every((item) => typeof item === 'number')) {
      return groups.filter((group: Group) => (groupsArr as number[]).includes(group.id));
    } else {
      return groupsArr;
    }
  };

  useLayoutEffect(() => {
    if (event) {
      initialGroupsForPublication(
        groups,
        getFullGroups(event.custom_groups),
        event.excluded_custom_groups
      );
    }
  }, [event, groups]);

  return (
    <>
      {isSearchMobile && (
        <>
          <PageTitle title="Публикация" />
          <PageHead
            Left={
              <IconButton
                variant="dark"
                onClick={() => {
                  setIsSearchMobile(!isSearchMobile);
                  onSearch('');
                }}
              >
                <ArrowBackIosNew fontSize="small" sx={{ transform: 'scale(0.8)' }} />
              </IconButton>
            }
            Right={
              <>{/*<Search mobile search={search} onSearch={onSearch} titles={groupTitles} />*/}</>
            }
          />
        </>
      )}

      {!isSearchMobile && (
        <>
          <PageTitle title="Публикация" />
          <PageHead
            Left={
              <button onClick={() => navigate(-1)}>
                <IconButton variant="dark">
                  <ArrowBackIosNew fontSize="small" sx={{ transform: 'scale(0.8)' }} />
                </IconButton>
              </button>
            }
            Right={
              <>
                {/* {windowWidth > 570 ? (
                  <Search search={search} onSearch={onSearch} titles={groupTitles} />
                ) : (
                  <IconButton variant="mobile" onClick={() => setIsSearchMobile(!isSearchMobile)}>
                    <SearchIcon />
                  </IconButton>
                )} */}
                {event && event.published && !areArraysEqual(selectedGroups, prevSelectedGroups) ? (
                  <button
                    type="submit"
                    className={st.done}
                    onClick={() => PublicationButtonClick()}
                  >
                    Готово
                  </button>
                ) : (
                  <button
                    type="submit"
                    className={st.submit}
                    onClick={() => {
                      publishAction?.action();
                      !areArraysEqual(selectedGroups, prevSelectedGroups) &&
                        PublicationButtonClick();
                    }}
                  >
                    {publishAction?.title}
                  </button>
                )}
              </>
            }
          />
        </>
      )}
      {status !== 'loaded' && <Loader />}
      {event && groups && status === 'loaded' && (
        <ListBody>
          <h3 className={st.all}>СТАТУС</h3>
          <Card className={st.publicationStatus}>
            {event.published ? 'Опубликовано' : 'Не опубликовано'}
          </Card>
          <h3 className={st.all}>ДЛЯ КОГО</h3>
          <AllToggle
            group={groupAll!}
            removeFromSelectedGroups={removeFromSelectedGroups}
            addSelectedToGroups={addSelectedToGroups}
            isSelectedAtAnyGroups={isSelectedAtAnyGroups}
          ></AllToggle>

          {sortGroups.map((group) => {
            if (
              group &&
              search !== '' &&
              group.name.toLowerCase().indexOf(search.toLowerCase()) !== -1
            )
              return (
                <CheckboxPublication
                  key={group.id}
                  group={group}
                  removeFromSelectedGroups={removeFromSelectedGroups}
                  addSelectedToGroups={addSelectedToGroups}
                  isSelectedAtAnyGroups={isSelectedAtAnyGroups}
                ></CheckboxPublication>
              );
            if (group && search === '')
              return (
                <CheckboxPublication
                  key={group.id}
                  group={group}
                  removeFromSelectedGroups={removeFromSelectedGroups}
                  addSelectedToGroups={addSelectedToGroups}
                  isSelectedAtAnyGroups={isSelectedAtAnyGroups}
                ></CheckboxPublication>
              );
          })}
        </ListBody>
      )}
    </>
  );
};
